import _ from "lodash";

import { displayDate, insertIf, schemaToCsvReport } from "@features/reports";
import { PurchaseOrder } from "@models/PurchaseOrder";
import { formatMoneyString, formatUtcDate } from "@utility/utilityFunctions";
import { CsvSchema } from "@utils/csv";

import { poTypeLabel } from "../helpers";
import { calcTotalCostPurchaseOrder } from "./purchasingHelpers";

export function purchaseOrderReport(organization) {
  const { hasPurchasingAgents } = organization;

  type ColumnType = CsvSchema<PurchaseOrder>;

  const columns: ColumnType = [
    { id: "id", label: "PO #" },
    { id: "type", label: "PO Type", f: (v) => poTypeLabel(v) },
    { id: "supplier.name", label: "Supplier" },
    { id: "supplierReference", label: "Supplier Reference" },
    { id: "invoiceNumber", label: "Invoice #" },
    ...insertIf<PurchaseOrder>(
      hasPurchasingAgents,
      {
        id: "purchasingAgentReferenceNumber",
        label: "External PO #",
      },
      {
        id: "purchasingAgentInvoiceNumber",
        label: "Purchasing Agent Invoice Number",
      }
    ),

    { id: "purchaserName", label: "Purchaser" },
    { id: "programNames", label: "Program" },

    {
      id: "totalProductCost",
      label: "Total Product Cost",
      f: formatMoneyString,
    },
    { id: "totalSetupFees", label: "Total Setup Fees", f: formatMoneyString },
    {
      id: "totalFreightCost",
      label: "Total Freight Cost",
      f: formatMoneyString,
    },
    { id: "totalTax", label: "Total Tax", f: formatMoneyString },
    {
      id: "_totalPOCost",
      label: "Grand Total",
      f: (_, row) => formatMoneyString(calcTotalCostPurchaseOrder(row)),
    },
    { id: "status", label: "PO Status", f: _.startCase },
    {
      id: "submittedAt",
      label: "Submitted Date",
      f: (d) => formatUtcDate(d),
    },
    {
      id: "inMarketDate",
      label: "In Market Date",
      f: displayDate,
    },
    ...insertIf(organization.hasBeacons, {
      id: "hasBeacons",
      label: "Has Beacons",
    }),
    { id: "shipmentCount", label: "Shipment Count" },
  ];

  return schemaToCsvReport(columns);
}
